(function () {
  'use strict';

  function parseCSVRow(row) {
    var result = [];
    var current = '';
    var inQuotes = false;
    for (var i = 0; i < row.length; i++) {
      var ch = row[i];
      if (ch === '"') {
        if (inQuotes && row[i + 1] === '"') { current += '"'; i++; }
        else { inQuotes = !inQuotes; }
      } else if (ch === ',' && !inQuotes) {
        result.push(current);
        current = '';
      } else {
        current += ch;
      }
    }
    result.push(current);
    return result;
  }

  function parseCSVToGeoJSON(text) {
    var lines = text.split(/\r?\n/);
    var headers = parseCSVRow(lines[0]).map(function (h) { return h.trim().toLowerCase(); });
    var features = [];
    for (var i = 1; i < lines.length; i++) {
      var line = lines[i].trim();
      if (!line) continue;
      var values = parseCSVRow(line);
      var row = {};
      for (var j = 0; j < headers.length; j++) {
        row[headers[j]] = values[j] ? values[j].trim() : '';
      }
      var lat = parseFloat(row.lat);
      var lng = parseFloat(row.lng || row.lon);
      if (isNaN(lat) || isNaN(lng)) continue;
      features.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [lng, lat] },
        properties: {
          name: row.name || '',
          addr: row.addr || row.address || '',
          city: row.city || '',
          prov: row.prov || row.province || row.state || '',
          postal: row.postal || row['postal code'] || row.zip || ''
        }
      });
    }
    return { type: 'FeatureCollection', features: features };
  }

  // isUS is now passed in — no longer fetched inside init(), removing a sequential network hop
  function init(geojson, isUS) {
    var container = document.getElementById('store-locator-section');
    if (!container) return;
    if (typeof mapboxgl === 'undefined') {
      console.error('Store Locator: mapboxgl not loaded');
      return;
    }

    var TOKEN = container.getAttribute('data-token');
    var GEOJSON = geojson;
    var DEFAULT_RADIUS = parseInt(container.getAttribute('data-radius') || '25', 10);
    var MAP_HEIGHT = container.getAttribute('data-map-height') || '440px';
    var SHEETS_WEBHOOK_URL = container.getAttribute('data-sheets-webhook-url') || '';
    var PAGE_SIZE = 8;
    var distanceUnit = isUS ? 'mi' : 'km';
    var earthRadius = isUS ? 3958.8 : 6371;

    var mapEl = document.getElementById('sl-map');
    if (mapEl) mapEl.style.height = MAP_HEIGHT;

    function toRad(degrees) {
      return degrees * Math.PI / 180;
    }

    function haversine(lat1, lng1, lat2, lng2) {
      var dLat = toRad(lat2 - lat1);
      var dLng = toRad(lng2 - lng1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function esc(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function getSessionId() {
      var storageKey = 'store_locator_session_id';
      try {
        var existing = window.sessionStorage.getItem(storageKey);
        if (existing) return existing;
        var sessionId = 'sl_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
        window.sessionStorage.setItem(storageKey, sessionId);
        return sessionId;
      } catch (error) {
        return 'sl_' + Date.now();
      }
    }

    function logStoreSelection(store, radius) {
      if (!SHEETS_WEBHOOK_URL) return;

      var payload = new URLSearchParams({
        event: 'store_selected',
        timestamp: new Date().toISOString(),
        session_id: getSessionId(),
        page_path: window.location.pathname,
        page_url: window.location.href,
        radius_km: String(radius),
        store_name: store.name || '',
        store_street: store.addr || '',
        store_city: store.city || '',
        store_province: store.prov || '',
        store_postal_code: store.postal || '',
        store_lat: String(store.lat || ''),
        store_lng: String(store.lng || '')
      });

      if (navigator.sendBeacon) {
        try {
          var beaconSent = navigator.sendBeacon(SHEETS_WEBHOOK_URL, payload);
          if (beaconSent) return;
        } catch (error) {}
      }

      fetch(SHEETS_WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: payload,
        keepalive: true,
        redirect: 'follow'
      }).catch(function (error) {
        console.warn('Store Locator logging failed.', error);
      });
    }

    function getStoreKey(store) {
      return [
        store.name || '',
        store.addr || '',
        store.city || '',
        store.prov || '',
        store.postal || ''
      ].join('||');
    }

    function buildPopupMarkup(store) {
      return '' +
        '<div class="store-locator__popup">' +
          '<div class="store-locator__popup-title">' + esc(store.name || '') + '</div>' +
          '<span class="store-locator__popup-address">' + esc([store.addr, store.city, store.prov].filter(Boolean).join(', ')) + '</span>' +
          '<span class="store-locator__popup-meta">' + esc(store.postal || '') + '</span>' +
        '</div>';
    }

    function emptyStateMarkup(title, text, iconVariant) {
      var icon = iconVariant === 'warning'
        ? '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"></circle><path d="M12 8v5" stroke-linecap="round"></path><circle cx="12" cy="16.5" r="0.5" fill="currentColor" stroke="none"></circle></svg>'
        : '<svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"></path><circle cx="12" cy="9" r="2.5"></circle></svg>';

      return '' +
        '<div class="store-locator__empty-state">' +
          '<div class="store-locator__empty-icon">' + icon + '</div>' +
          '<p class="store-locator__empty-title">' + esc(title) + '</p>' +
          '<p class="store-locator__empty-text">' + esc(text) + '</p>' +
        '</div>';
    }

    var addrInput = document.getElementById('sl-addr-input');
    var sugBox = document.getElementById('sl-suggestions');
    var errEl = document.getElementById('sl-error');
    var searchBtn = document.getElementById('sl-search-btn');
    var radiusSel = document.getElementById('sl-radius');
    var storeList = document.getElementById('sl-store-list');
    var resultsBar = document.getElementById('sl-results-bar');
    var resultsCount = document.getElementById('sl-results-count');
    var resultsLabel = document.getElementById('sl-results-label');
    var resultsRadius = document.getElementById('sl-results-radius');
    var pagination = document.getElementById('sl-pagination');

    var debounceTimer = null;
    var selectedCoords = null;
    var lastFeatures = [];
    var userMarker = null;
    var activePopup = null;
    var currentResults = [];
    var currentPage = 1;
    var currentRadius = DEFAULT_RADIUS;
    var activeStoreKey = '';
    var geocodeCache = {};
    var sugAbortController = null;
    var sugHighlightIndex = -1;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var map;

    function setResultsSummary(count, radius) {
      resultsBar.hidden = false;
      resultsCount.textContent = count;
      resultsLabel.textContent = count === 1 ? 'store found' : 'stores found';
      resultsRadius.textContent = radius + ' ' + distanceUnit + ' radius';
    }

    function openPopup(store) {
      if (activePopup) activePopup.remove();
      activePopup = new mapboxgl.Popup({ offset: 14, focusAfterOpen: false })
        .setLngLat([store.lng, store.lat])
        .setHTML(buildPopupMarkup(store))
        .addTo(map);
    }

    function resetBtn() {
      searchBtn.textContent = 'Find Stores';
      searchBtn.disabled = false;
    }

    function hideSug() {
      sugBox.classList.remove('is-open');
      sugBox.innerHTML = '';
      sugHighlightIndex = -1;
      addrInput.setAttribute('aria-expanded', 'false');
      addrInput.removeAttribute('aria-activedescendant');
    }

    function updateSugHighlight(items) {
      for (var k = 0; k < items.length; k++) {
        var focused = k === sugHighlightIndex;
        items[k].classList.toggle('is-focused', focused);
        items[k].setAttribute('aria-selected', focused ? 'true' : 'false');
      }
      if (sugHighlightIndex >= 0) {
        addrInput.setAttribute('aria-activedescendant', 'sl-sug-' + sugHighlightIndex);
      } else {
        addrInput.removeAttribute('aria-activedescendant');
      }
    }

    function getPageNumbers(current, total) {
      if (total <= 5) {
        return Array.from({ length: total }, function (_, index) { return index + 1; });
      }
      if (current <= 3) return [1, 2, 3, '…', total];
      if (current >= total - 2) return [1, '…', total - 2, total - 1, total];
      return [1, '…', current - 1, current, current + 1, '…', total];
    }

    function renderPagination() {
      var totalPages = Math.ceil(currentResults.length / PAGE_SIZE);
      pagination.hidden = totalPages <= 1;
      if (totalPages <= 1) {
        pagination.innerHTML = '';
        return;
      }

      pagination.innerHTML = '';

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'store-locator__page-btn';
      prev.disabled = currentPage === 1;
      prev.setAttribute('aria-label', 'Previous page');
      prev.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      prev.addEventListener('click', function () {
        currentPage -= 1;
        renderResultsPage();
      });
      pagination.appendChild(prev);

      var pages = getPageNumbers(currentPage, totalPages);
      for (var i = 0; i < pages.length; i++) {
        if (pages[i] === '…') {
          var ellipsis = document.createElement('span');
          ellipsis.className = 'store-locator__page-ellipsis';
          ellipsis.textContent = '…';
          pagination.appendChild(ellipsis);
          continue;
        }

        (function (pageNumber) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'store-locator__page-btn' + (pageNumber === currentPage ? ' is-active' : '');
          btn.textContent = pageNumber;
          btn.setAttribute('aria-label', 'Page ' + pageNumber);
          if (pageNumber === currentPage) btn.setAttribute('aria-current', 'page');
          btn.addEventListener('click', function () {
            currentPage = pageNumber;
            renderResultsPage();
          });
          pagination.appendChild(btn);
        })(pages[i]);
      }

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'store-locator__page-btn';
      next.disabled = currentPage === totalPages;
      next.setAttribute('aria-label', 'Next page');
      next.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      next.addEventListener('click', function () {
        currentPage += 1;
        renderResultsPage();
      });
      pagination.appendChild(next);
    }

    function ensureActiveStoreVisible() {
      if (!activeStoreKey || !currentResults.length) return;
      for (var i = 0; i < currentResults.length; i++) {
        if (getStoreKey(currentResults[i]) === activeStoreKey) {
          currentPage = Math.floor(i / PAGE_SIZE) + 1;
          return;
        }
      }
    }

    function renderResultsPage() {
      storeList.innerHTML = '';

      if (!currentResults.length) {
        pagination.hidden = true;
        pagination.innerHTML = '';
        storeList.innerHTML = emptyStateMarkup(
          'No stores found',
          'Try expanding your search radius or searching a nearby city.',
          'warning'
        );
        return;
      }

      var start = (currentPage - 1) * PAGE_SIZE;
      var pageStores = currentResults.slice(start, start + PAGE_SIZE);

      for (var i = 0; i < pageStores.length; i++) {
        (function (store, indexOnPage) {
          var globalIndex = start + indexOnPage;
          var storeKey = getStoreKey(store);
          var isActive = storeKey === activeStoreKey;
          var mapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' +
            encodeURIComponent([store.addr, store.city, store.prov, store.postal].filter(Boolean).join(', '));

          var card = document.createElement('div');
          card.className = 'store-locator__card' + (isActive ? ' is-active' : '');
          card.style.animationDelay = indexOnPage * 25 + 'ms';
          card.setAttribute('data-store-key', storeKey);
          card.setAttribute('role', 'button');
          card.setAttribute('tabindex', '0');
          card.setAttribute('aria-label', 'Select ' + store.name + (store.city ? ', ' + store.city : ''));
          card.innerHTML = '' +
            '<span class="store-locator__card-num">' + (globalIndex + 1) + '</span>' +
            '<span class="store-locator__card-main">' +
              '<span class="store-locator__card-name">' + esc(store.name) + '</span>' +
              '<span class="store-locator__card-addr">' + esc([store.addr, store.city, store.prov, store.postal].filter(Boolean).join(', ')) + '</span>' +
              '<a class="store-locator__directions" href="' + mapsUrl + '" target="_blank" rel="noopener noreferrer" aria-label="Get directions to ' + esc(store.name) + '">' +
                '<svg aria-hidden="true" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L12 22M2 12l10-10 10 10"/></svg>' +
                'Get Directions' +
              '</a>' +
            '</span>' +
            '<span class="store-locator__card-side">' +
              '<span class="store-locator__card-dist">' + store.dist.toFixed(1) + ' ' + distanceUnit + '</span>' +
              '<span class="store-locator__card-note">away</span>' +
            '</span>';

          card.addEventListener('click', function (e) {
            if (e.target.closest('.store-locator__directions')) return;
            var prevActive = storeList.querySelector('.store-locator__card.is-active');
            if (prevActive) prevActive.classList.remove('is-active');
            card.classList.add('is-active');
            activeStoreKey = storeKey;
            logStoreSelection(store, currentRadius);
            map.flyTo({ center: [store.lng, store.lat], zoom: 15, duration: prefersReducedMotion ? 0 : 650 });
            openPopup(store);
          });

          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              card.click();
            }
          });

          storeList.appendChild(card);
        })(pageStores[i], i);
      }

      renderPagination();
    }

    function fetchSug(query) {
      if (sugAbortController) sugAbortController.abort();
      sugAbortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var fetchOptions = sugAbortController ? { signal: sugAbortController.signal } : {};
      fetch(
        'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
        encodeURIComponent(query) +
        '.json?access_token=' + TOKEN + '&country=CA,US&types=address,postcode,place,locality&autocomplete=true&limit=5',
        fetchOptions
      )
        .then(function (response) { return response.json(); })
        .then(function (data) {
          lastFeatures = data.features || [];
          renderSug(lastFeatures);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          hideSug();
        });
    }

    function renderSug(features) {
      if (!features.length) {
        hideSug();
        return;
      }

      sugHighlightIndex = -1;
      var html = '';
      for (var i = 0; i < features.length; i++) {
        var feature = features[i];
        var main = feature.text || feature.place_name.split(',')[0];
        var rest = feature.place_name.indexOf(',') !== -1
          ? feature.place_name.slice(feature.place_name.indexOf(',') + 1).trim()
          : '';

        html += '' +
          '<div class="store-locator__sug-item" role="option" aria-selected="false" id="sl-sug-' + i + '" data-idx="' + i + '">' +
            '<span class="store-locator__sug-pin" aria-hidden="true">' +
              '<svg width="11" height="13" viewBox="0 0 12 15" fill="none"><path d="M6 0C3.24 0 1 2.24 1 5c0 3.75 5 9 5 9s5-5.25 5-9c0-2.76-2.24-5-5-5z" fill="currentColor"></path><circle cx="6" cy="5" r="1.8" fill="white"></circle></svg>' +
            '</span>' +
            '<span class="store-locator__sug-copy">' +
              '<span class="store-locator__sug-main">' + esc(main) + '</span>' +
              (rest ? '<span class="store-locator__sug-sub">' + esc(rest) + '</span>' : '') +
            '</span>' +
          '</div>';
      }

      sugBox.innerHTML = html;
      sugBox.classList.add('is-open');
      addrInput.setAttribute('aria-expanded', 'true');

      var items = sugBox.querySelectorAll('.store-locator__sug-item');
      for (var j = 0; j < items.length; j++) {
        (function (item) {
          item.addEventListener('mousedown', function (event) {
            event.preventDefault();
            var feature = lastFeatures[parseInt(item.getAttribute('data-idx'), 10)];
            addrInput.value = feature.place_name;
            selectedCoords = { lat: feature.center[1], lng: feature.center[0] };
            hideSug();
            doSearch();
          });
        })(items[j]);
      }
    }

    function runSearch(coords, radius) {
      resetBtn();
      if (activePopup) {
        activePopup.remove();
        activePopup = null;
      }

      var latDelta = radius / 111;
      var lngDelta = radius / (111 * Math.cos(toRad(coords.lat)));
      var minLat = coords.lat - latDelta;
      var maxLat = coords.lat + latDelta;
      var minLng = coords.lng - lngDelta;
      var maxLng = coords.lng + lngDelta;

      var results = [];
      var features = GEOJSON.features;
      for (var i = 0; i < features.length; i++) {
        var feature = features[i];
        var lng = feature.geometry.coordinates[0];
        var lat = feature.geometry.coordinates[1];
        if (lat < minLat || lat > maxLat || lng < minLng || lng > maxLng) continue;
        var distance = haversine(coords.lat, coords.lng, lat, lng);

        if (distance <= radius) {
          results.push({
            name: feature.properties.name,
            addr: feature.properties.addr,
            city: feature.properties.city,
            prov: feature.properties.prov,
            postal: feature.properties.postal,
            lat: lat,
            lng: lng,
            dist: distance
          });
        }
      }

      results.sort(function (a, b) {
        return a.dist - b.dist;
      });

      currentResults = results;
      currentPage = 1;
      currentRadius = radius;
      activeStoreKey = results.length ? getStoreKey(results[0]) : '';

      if (userMarker) userMarker.remove();
      var markerEl = document.createElement('div');
      markerEl.style.cssText = [
        'width:13px',
        'height:13px',
        'border-radius:50%',
        'background:#1c1108',
        'border:2.5px solid #fff',
        'box-shadow:0 0 0 4px rgba(28,17,8,0.12),0 2px 8px rgba(0,0,0,0.25)'
      ].join(';');
      userMarker = new mapboxgl.Marker({ element: markerEl })
        .setLngLat([coords.lng, coords.lat])
        .addTo(map);

      setResultsSummary(results.length, radius);

      var animDuration = prefersReducedMotion ? 0 : 900;

      if (!results.length) {
        renderResultsPage();
        map.flyTo({ center: [coords.lng, coords.lat], zoom: 10.5, duration: animDuration });
        return;
      }

      var bounds = new mapboxgl.LngLatBounds([coords.lng, coords.lat], [coords.lng, coords.lat]);
      for (var j = 0; j < results.length; j++) {
        bounds.extend([results[j].lng, results[j].lat]);
      }

      map.fitBounds(bounds, {
        padding: { top: 64, right: 80, bottom: 64, left: 80 },
        maxZoom: 13,
        duration: animDuration
      });

      renderResultsPage();
    }

    function doSearch() {
      var query = addrInput.value.trim();
      var radius = parseInt(radiusSel.value, 10);
      errEl.textContent = '';

      if (!query) {
        errEl.textContent = 'Please enter an address or postal code.';
        return;
      }

      searchBtn.textContent = 'Searching...';
      searchBtn.disabled = true;

      if (selectedCoords) {
        runSearch(selectedCoords, radius);
        return;
      }

      var cacheKey = query.toLowerCase();
      if (geocodeCache[cacheKey]) {
        runSearch(geocodeCache[cacheKey], radius);
        return;
      }

      fetch(
        'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
        encodeURIComponent(query) +
        '.json?access_token=' + TOKEN + '&country=CA,US&types=address,postcode,place,locality&limit=1'
      )
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.features && data.features.length) {
            var coords = { lat: data.features[0].center[1], lng: data.features[0].center[0] };
            geocodeCache[cacheKey] = coords;
            runSearch(coords, radius);
          } else {
            resetBtn();
            errEl.textContent = 'Location not found. Try a different address or postal code.';
          }
        })
        .catch(function () {
          resetBtn();
          errEl.textContent = 'Something went wrong. Please try again.';
        });
    }

    // isUS is already resolved — skip the geojs.io fetch and go straight to startLocator
    startLocator();

    function startLocator() {
      if (addrInput) {
        addrInput.placeholder = isUS ? 'Enter ZIP code or city...' : 'Enter postal code or city...';
      }

      if (radiusSel) {
        if (isUS) {
          for (var i = 0; i < radiusSel.options.length; i++) {
            radiusSel.options[i].text = radiusSel.options[i].text.replace('km', 'mi');
          }
        }
        for (var j = 0; j < radiusSel.options.length; j++) {
          if (parseInt(radiusSel.options[j].value, 10) === DEFAULT_RADIUS) {
            radiusSel.options[j].selected = true;
            break;
          }
        }
      }

      addrInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        selectedCoords = null;
        var query = addrInput.value.trim();
        if (query.length < 2) {
          hideSug();
          return;
        }
        debounceTimer = setTimeout(function () {
          fetchSug(query);
        }, 300);
      });

      addrInput.addEventListener('keydown', function (event) {
        var items = sugBox.querySelectorAll('.store-locator__sug-item');
        if (items.length && sugBox.classList.contains('is-open')) {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            sugHighlightIndex = Math.min(sugHighlightIndex + 1, items.length - 1);
            updateSugHighlight(items);
            return;
          }
          if (event.key === 'ArrowUp') {
            event.preventDefault();
            sugHighlightIndex = Math.max(sugHighlightIndex - 1, -1);
            updateSugHighlight(items);
            return;
          }
          if (event.key === 'Enter' && sugHighlightIndex >= 0) {
            event.preventDefault();
            items[sugHighlightIndex].dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
            sugHighlightIndex = -1;
            return;
          }
        }
        if (event.key === 'Enter') {
          hideSug();
          doSearch();
        }
        if (event.key === 'Escape') {
          hideSug();
          addrInput.focus();
        }
      });

      document.addEventListener('mousedown', function (event) {
        if (!event.target.closest('.store-locator__input-wrap')) hideSug();
      });

      searchBtn.addEventListener('click', doSearch);

      var geoBtn = document.getElementById('sl-geo-btn');
      if (geoBtn) {
        if (!navigator.geolocation) {
          geoBtn.style.display = 'none';
        } else {
          geoBtn.addEventListener('click', function () {
            geoBtn.classList.add('is-loading');
            geoBtn.textContent = 'Locating…';
            errEl.textContent = '';

            navigator.geolocation.getCurrentPosition(
              function (position) {
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                selectedCoords = { lat: lat, lng: lng };

                fetch(
                  'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
                  lng + ',' + lat +
                  '.json?access_token=' + TOKEN + '&types=address,postcode,place&limit=1'
                )
                  .then(function (res) { return res.json(); })
                  .then(function (data) {
                    if (data.features && data.features.length) {
                      addrInput.value = data.features[0].place_name;
                    } else {
                      addrInput.value = lat.toFixed(5) + ', ' + lng.toFixed(5);
                    }
                    geoBtn.classList.remove('is-loading');
                    geoBtn.innerHTML = '<svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M12 2v3M12 19v3M2 12h3M19 12h3"></path><circle cx="12" cy="12" r="9" stroke-dasharray="2 4"></circle></svg> Use my location';
                    doSearch();
                  })
                  .catch(function () {
                    addrInput.value = lat.toFixed(5) + ', ' + lng.toFixed(5);
                    geoBtn.classList.remove('is-loading');
                    geoBtn.innerHTML = '<svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M12 2v3M12 19v3M2 12h3M19 12h3"></path><circle cx="12" cy="12" r="9" stroke-dasharray="2 4"></circle></svg> Use my location';
                    doSearch();
                  });
              },
              function (err) {
                geoBtn.classList.remove('is-loading');
                geoBtn.innerHTML = '<svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M12 2v3M12 19v3M2 12h3M19 12h3"></path><circle cx="12" cy="12" r="9" stroke-dasharray="2 4"></circle></svg> Use my location';
                if (err.code === err.PERMISSION_DENIED) {
                  errEl.textContent = 'Location access denied. Please enter your address manually.';
                } else if (err.code === err.POSITION_UNAVAILABLE) {
                  errEl.textContent = 'Location unavailable. Please enter your address manually.';
                } else {
                  errEl.textContent = 'Could not get your location. Please enter your address manually.';
                }
              },
              { timeout: 10000, maximumAge: 60000 }
            );
          });
        }
      }

      mapboxgl.accessToken = TOKEN;
      map = new mapboxgl.Map({
        container: 'sl-map',
        style: 'mapbox://styles/mapbox/streets-v12',
        attributionControl: false,
        center: isUS ? [-74.0060, 40.7128] : [-79.3832, 43.6532],
        zoom: 5,
        // Tiles appear instantly rather than fading in
        fadeDuration: 0,
        // Skip rendering duplicate world copies — saves tile fetches
        renderWorldCopies: false
      });

      map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
      map.addControl(new mapboxgl.AttributionControl({ compact: true }), 'bottom-right');

      map.on('load', function () {
        map.addSource('stores', {
          type: 'geojson',
          data: GEOJSON,
          cluster: true,
          clusterMaxZoom: 12,
          clusterRadius: 50
        });

        map.addLayer({
          id: 'clusters',
          type: 'circle',
          source: 'stores',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': [
              'step',
              ['get', 'point_count'],
              '#c4936a',
              10, '#a8652a',
              50, '#7a4820',
              100, '#3d2010'
            ],
            'circle-radius': [
              'step',
              ['get', 'point_count'],
              17,
              10, 23,
              50, 29,
              100, 37
            ],
            'circle-stroke-width': 2,
            'circle-stroke-color': 'rgba(255,255,255,0.9)',
            'circle-opacity': 0.92
          }
        });

        map.addLayer({
          id: 'cluster-count',
          type: 'symbol',
          source: 'stores',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12
          },
          paint: { 'text-color': '#ffffff' }
        });

        map.addLayer({
          id: 'unclustered-point',
          type: 'circle',
          source: 'stores',
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': '#7a4820',
            'circle-radius': 7,
            'circle-stroke-width': 2,
            'circle-stroke-color': 'rgba(255,255,255,0.95)',
            'circle-opacity': 0.95
          }
        });

        map.on('click', 'clusters', function (event) {
          var features = map.queryRenderedFeatures(event.point, { layers: ['clusters'] });
          if (!features.length) return;
          map.getSource('stores').getClusterExpansionZoom(features[0].properties.cluster_id, function (error, zoom) {
            if (error) return;
            map.easeTo({ center: features[0].geometry.coordinates, zoom: zoom + 0.5, duration: prefersReducedMotion ? 0 : 300 });
          });
        });

        map.on('click', 'unclustered-point', function (event) {
          var properties = event.features[0].properties;
          var coordinates = event.features[0].geometry.coordinates.slice();
          var store = {
            name: properties.name || '',
            addr: properties.addr || '',
            city: properties.city || '',
            prov: properties.prov || '',
            postal: properties.postal || '',
            lat: coordinates[1],
            lng: coordinates[0]
          };

          logStoreSelection(store, currentRadius || DEFAULT_RADIUS);
          openPopup(store);

          if (currentResults.length) {
            activeStoreKey = getStoreKey(store);
            ensureActiveStoreVisible();
            renderResultsPage();
          }
        });

        map.on('mouseenter', 'clusters', function () {
          map.getCanvas().style.cursor = 'pointer';
        });

        map.on('mouseleave', 'clusters', function () {
          map.getCanvas().style.cursor = '';
        });

        map.on('mouseenter', 'unclustered-point', function () {
          map.getCanvas().style.cursor = 'pointer';
        });

        map.on('mouseleave', 'unclustered-point', function () {
          map.getCanvas().style.cursor = '';
        });
      });
    }
  }

  function loadAndInit() {
    var container = document.getElementById('store-locator-section');
    if (!container) return;

    // Pre-warm Mapbox CDN connections immediately — before any data is fetched
    if (typeof mapboxgl !== 'undefined') {
      try { mapboxgl.prewarm(); } catch (e) {}
    }

    var useSheet = container.getAttribute('data-use-sheet') === 'true';
    var sheetUrl = container.getAttribute('data-sheet-url') || '';

    // Default mode: load instantly from bundled JSON (window.ZorawsStoreData)
    if (!useSheet) {
      console.log('[StoreLocator] Using bundled JSON (fast path)');

      // Default to CA immediately so we can render without waiting on a network call.
      // Detect country in the background and patch labels to mi/ZIP if needed.
      function startWithData(data) {
        init(data, false);
        fetch('https://get.geojs.io/v1/ip/country.json')
          .then(function (res) { return res.json(); })
          .catch(function () { return { country: 'CA' }; })
          .then(function (geoData) {
            if (geoData && geoData.country === 'US') {
              var input = document.getElementById('sl-addr-input');
              if (input) input.placeholder = 'Enter ZIP code or city...';
              var radius = document.getElementById('sl-radius');
              if (radius) {
                for (var i = 0; i < radius.options.length; i++) {
                  radius.options[i].text = radius.options[i].text.replace('km', 'mi');
                }
              }
            }
          });
      }

      // Defer-loaded scripts execute in document order, so ZorawsStoreData is
      // almost always already defined by the time this runs — start synchronously.
      if (window.ZorawsStoreData) {
        startWithData(window.ZorawsStoreData);
        return;
      }

      // Fallback poll only if data script hasn't run yet (race / cache miss).
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (window.ZorawsStoreData) {
          clearInterval(poll);
          startWithData(window.ZorawsStoreData);
        } else if (attempts > 200) {
          clearInterval(poll);
          console.error('Store Locator: window.ZorawsStoreData was not loaded. Make sure assets/store-locator-data.js exists and defines it.');
        }
      }, 25);
      return;
    }

    console.log('[StoreLocator] Using Google Sheet (slow path)');

    // Google Sheet mode (slower)
    if (!sheetUrl) {
      console.error('Store Locator: "Use Google Sheet" is enabled but no data-sheet-url is set.');
      return;
    }

    var listEl = document.getElementById('sl-store-list');
    var initialListHTML = listEl ? listEl.innerHTML : '';

    if (listEl) {
      listEl.innerHTML =
        '<div class="store-locator__empty-state">' +
          '<div class="store-locator__spinner" aria-hidden="true"></div>' +
          '<p class="store-locator__empty-title">Loading stores\u2026</p>' +
        '</div>';
    }

    // Cache CSV in sessionStorage so back-navigations and repeat loads are instant
    var CSV_CACHE_KEY = 'sl_csv_v1_' + sheetUrl;
    var cachedCSV = null;
    try { cachedCSV = sessionStorage.getItem(CSV_CACHE_KEY); } catch (e) {}

    var csvPromise = cachedCSV
      ? Promise.resolve(cachedCSV)
      : fetch(sheetUrl)
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (csv) {
            try { sessionStorage.setItem(CSV_CACHE_KEY, csv); } catch (e) {}
            return csv;
          });

    // Fire geojs.io in parallel with the CSV fetch — not after it
    var geoPromise = fetch('https://get.geojs.io/v1/ip/country.json')
      .then(function (res) { return res.json(); })
      .catch(function () { return { country: 'CA' }; });

    // Both network calls race concurrently; we proceed as soon as both resolve
    Promise.all([
      csvPromise.then(function (csv) { return parseCSVToGeoJSON(csv); }),
      geoPromise
    ])
      .then(function (results) {
        var geojson = results[0];
        var geoData = results[1];
        if (!geojson.features.length) {
          console.warn('Store Locator: sheet loaded but no valid rows found. Check column headers (name, addr, city, prov, postal, lat, lng).');
        }
        if (listEl) listEl.innerHTML = initialListHTML;
        init(geojson, geoData.country === 'US');
      })
      .catch(function (err) {
        console.error('Store Locator: failed to load sheet data.', err);
        if (listEl) {
          listEl.innerHTML =
            '<div class="store-locator__empty-state">' +
              '<p class="store-locator__empty-title">Could not load store data</p>' +
              '<p class="store-locator__empty-text">Please try refreshing the page.</p>' +
            '</div>';
        }
      });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-sl-src="' + src + '"]');
      if (existing) {
        if (existing.getAttribute('data-sl-loaded') === 'true') return resolve();
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', function () { reject(new Error('Failed: ' + src)); });
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = false;
      s.setAttribute('data-sl-src', src);
      s.onload = function () { s.setAttribute('data-sl-loaded', 'true'); resolve(); };
      s.onerror = function () { reject(new Error('Failed: ' + src)); };
      document.head.appendChild(s);
    });
  }

  var heavyLoadPromise = null;
  function ensureHeavyLoaded() {
    if (heavyLoadPromise) return heavyLoadPromise;
    var container = document.getElementById('store-locator-section');
    if (!container) return Promise.resolve();

    var useSheet = container.getAttribute('data-use-sheet') === 'true';
    var dataUrl = container.getAttribute('data-data-url') || '';
    var mapboxUrl = container.getAttribute('data-mapbox-js') ||
                    'https://api.mapbox.com/mapbox-gl-js/v3.3.0/mapbox-gl.js';

    var jobs = [];
    if (typeof window.mapboxgl === 'undefined') {
      jobs.push(loadScript(mapboxUrl));
    }
    if (!useSheet && !window.ZorawsStoreData && dataUrl) {
      jobs.push(loadScript(dataUrl));
    }

    heavyLoadPromise = Promise.all(jobs)
      .then(function () {
        loadAndInit();
        // Init runs synchronously up through map creation; remove placeholder class
        // once Mapbox starts rendering tiles.
        container.classList.remove('is-map-pending');
        // If user typed a query before init was ready, fire the search now.
        var inp = document.getElementById('sl-addr-input');
        var btn = document.getElementById('sl-search-btn');
        if (inp && btn && inp.value.trim().length >= 2) {
          btn.click();
        }
      })
      .catch(function (err) {
        console.error('[StoreLocator] Failed to load assets:', err);
        container.classList.remove('is-map-pending');
      });

    return heavyLoadPromise;
  }

  function setupBootstrap() {
    var container = document.getElementById('store-locator-section');
    if (!container) return;

    var triggered = false;
    function trigger(reason) {
      if (triggered) return;
      triggered = true;
      console.log('[StoreLocator] Lazy-loading map (' + reason + ')');
      ensureHeavyLoaded();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.disconnect();
            trigger('viewport');
            return;
          }
        }
      }, { rootMargin: '500px 0px' });
      io.observe(container);
    }

    var input = document.getElementById('sl-addr-input');
    if (input) {
      input.addEventListener('focus', function () { trigger('input-focus'); }, { once: true });
    }
    container.addEventListener('pointerdown', function () { trigger('pointer'); }, { once: true });
    container.addEventListener('touchstart', function () { trigger('touch'); }, { once: true, passive: true });

    var idleFire = function () { trigger('idle'); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(idleFire, { timeout: 2500 });
    } else {
      setTimeout(idleFire, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupBootstrap);
  } else {
    setupBootstrap();
  }
})();
